
import { ClientAdmissionEffects } from './clientAdmission.effects';
import { EmailValidateEffects } from './emailValidate.effects';
import { IsCTSEmployeeEffects } from './isCTSEmployee.effects';
import { GetRequestManagerEffects } from './getRequestManager.effects';
import { ReqManagerCreateffects } from './reqManagerCreate.effects';
import { AddressManagerCreateEffects } from './addressManagerCreate.effects';
import { LaborManagerCreateEffects } from './laborManagerCreate.effects';
import { NationalityManagerCreateEffects } from './nationalityManagerCreate.effects';
import { CurrencyTypeEffects } from './currencyType.effects';
import { FinancialDataManagerCreateEffects } from './financialDataManagerCreate.effects';
import { PassiveDocumentCreationEffects } from './passiveDocumentCreation.effects';
import { TermsAndConditionsManagerCreateEffects } from './termsAndConditionsManagerCreate.effects';
import { CustomerChallengeGenerateEffects } from './customerChallengeGenerate.effects';
import { CheckTokenEffects } from './checkToken.effects';
import { PasswordCreateEffects } from './passwordCreate.effects';
import { CreateUserAccountEffects } from './createUserAccount.effects';
import { CigoEffects } from './cigo.effects';
import { CreateProductEffects } from './createProduct.effects';
import { PioEffects } from './pio.effects';
import { ClientStatePasswordGetEffects } from './clientStatePasswordGet.effects';
import { DocumentSignatureEffects } from './documentSignature.effects';
import { TriEffects } from './tri.effects';
import { TreEffects } from './tre.effects';
import { ValidateSessionEffects } from './validateSession.effects';
import { UIEffects } from './ui.effects';
export const EffectsArray: any[] = [
    ClientAdmissionEffects,
    EmailValidateEffects,
    FinancialDataManagerCreateEffects,
    IsCTSEmployeeEffects,
    AddressManagerCreateEffects,
    GetRequestManagerEffects,
    ReqManagerCreateffects,
    LaborManagerCreateEffects,
    NationalityManagerCreateEffects,
    CurrencyTypeEffects,
    TermsAndConditionsManagerCreateEffects,
    PassiveDocumentCreationEffects,
    CustomerChallengeGenerateEffects,
    CheckTokenEffects,
    PasswordCreateEffects,
    CigoEffects,
    CreateUserAccountEffects,
    CreateProductEffects,
    PioEffects,
    ClientStatePasswordGetEffects,
    DocumentSignatureEffects,
    TriEffects,
    ValidateSessionEffects,
    TreEffects,
    UIEffects
];
